var ArenaEvent = {}

// 更新循环赛的个人信息
ArenaEvent.UpdateMyLoopData = "ArenaEvent.UpdateMyLoopData"

// 更新循环赛挑战次数奖励信息
ArenaEvent.UpdateLoopChallengeTimesList = "ArenaEvent.UpdateLoopChallengeTimesList"

// 更新循环赛的挑战列表
ArenaEvent.UpdateLoopChallengeList = "ArenaEvent.UpdateLoopChallengeList"

// 更新循环赛列表单元
ArenaEvent.UpdateLoopChallengeListItem = "ArenaEvent.UpdateLoopChallengeListItem"

// 更新循环赛前三排行榜数据
ArenaEvent.UpdateLoopChallengeStatueList = "ArenaEvent.UpdateLoopChallengeStatueList"

// 更新循环赛排行榜数据
ArenaEvent.UpdateLoopChallengeRank = "ArenaEvent:UpdateLoopChallengeRank "

// 竞技场红点状态
ArenaEvent.UpdateArenaRedStatus = "ArenaEvent.UpdateArenaRedStatus"

// 购买挑战劵返回
ArenaEvent.UpdateArena_Number = "ArenaEvent.UpdateArena_Number"

//冠军赛
ArenaEvent.CheckFightInfoEvent = "ArenaEvent.CheckFightInfoEvent"
ArenaEvent.ChangeTanFromTop324 = "ArenaEvent.ChangeTanFromTop324"

// 冠军赛基础信息时间
ArenaEvent.UpdateChampionBaseInfoEvent = "ArenaEvent.UpdateChampionBaseInfoEvent"
// 个人基础信息
ArenaEvent.UpdateChampionRoleInfoEvent = "ArenaEvent.UpdateChampionRoleInfoEvent"
// 更新冠军赛top3的数据
ArenaEvent.UpdateChampionTop3Event = "ArenaEvent.UpdateChampionTop3Event"
// 更新我的选拔赛数据
ArenaEvent.UpdateMyMatchInfoEvent = "ArenaEvent.UpdateMyMatchInfoEvent"
// 更新竞猜的比赛数据
ArenaEvent.UpdateGuessMatchInfoEvent = "ArenaEvent.UpdateGuessMatchInfoEvent"
// 押注某场比赛的返回
ArenaEvent.UpdateBetMatchValueEvent = "ArenaEvent.UpdateBetMatchValueEvent"
// 我的竞猜更新
ArenaEvent.UpdateMyGuessListEvent = "ArenaEvent.UpdateMyGuessListEvent"
// 冠军赛排行榜
ArenaEvent.UpdateChampionRankEvent = "ArenaEvent.UpdateChampionRankEvent"
// 32强数据
ArenaEvent.UpdateTop32InfoEvent = "ArenaEvent.UpdateTop32InfoEvent"
// 4强数据
ArenaEvent.UpdateTop4InfoEvent = "ArenaEvent.UpdateTop4InfoEvent"
// 32强或者4强赛竞猜位置信息
ArenaEvent.UpdateTop324GuessGroupEvent = "ArenaEvent.UpdateTop324GuessGroupEvent"
// 32或者4强赛指定位置的信息
ArenaEvent.UpdateTop324GroupPosEvent = "ArenaEvent.UpdateTop324GroupPosEvent"
// 冠军赛可押注资产变化
ArenaEvent.UpdateRoleInfoBetEvent = "ArenaEvent.UpdateRoleInfoBetEvent"
// 我的战斗日志
ArenaEvent.UpdateMylogListEvent = "ArenaEvent.UpdateMylogListEvent"

module.exports = ArenaEvent;